import { ErrorMessage as BaseErrorMessage } from '@distribusion/owl-frontend-ui'
import React, { ReactElement } from 'react'

import { useTranslation } from '@lib/i18n'

interface ErrorMessageProps {
  code?: ErrorCode
  className?: string
  fallbackMessage?: string | null
  forcedMessage?: string | null
}

const ErrorMessage = ({ code, fallbackMessage, className, forcedMessage }: ErrorMessageProps): ReactElement => {
  const { t } = useTranslation()
  const defaultError = fallbackMessage ?? 'errors.internalError'

  return (
    <BaseErrorMessage className={className}>
      {forcedMessage ?? t([`errors.${code as string}`, defaultError])}
    </BaseErrorMessage>
  )
}

export default ErrorMessage
